export default "__VITE_ASSET__22830864__"